/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCheckoutTimelines200ResponseAllOfData } from './GetCheckoutTimelines200ResponseAllOfData';
import {
    GetCheckoutTimelines200ResponseAllOfDataFromJSON,
    GetCheckoutTimelines200ResponseAllOfDataFromJSONTyped,
    GetCheckoutTimelines200ResponseAllOfDataToJSON,
} from './GetCheckoutTimelines200ResponseAllOfData';
import type { ResponseSuccessWithPagingAllOfMeta } from './ResponseSuccessWithPagingAllOfMeta';
import {
    ResponseSuccessWithPagingAllOfMetaFromJSON,
    ResponseSuccessWithPagingAllOfMetaFromJSONTyped,
    ResponseSuccessWithPagingAllOfMetaToJSON,
} from './ResponseSuccessWithPagingAllOfMeta';

/**
 * 
 * @export
 * @interface GetCheckoutTimelines200Response
 */
export interface GetCheckoutTimelines200Response {
    /**
     * 
     * @type {GetCheckoutTimelines200ResponseAllOfData}
     * @memberof GetCheckoutTimelines200Response
     */
    data: GetCheckoutTimelines200ResponseAllOfData;
    /**
     * 
     * @type {ResponseSuccessWithPagingAllOfMeta}
     * @memberof GetCheckoutTimelines200Response
     */
    meta: ResponseSuccessWithPagingAllOfMeta;
}

/**
 * Check if a given object implements the GetCheckoutTimelines200Response interface.
 */
export function instanceOfGetCheckoutTimelines200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCheckoutTimelines200ResponseFromJSON(json: any): GetCheckoutTimelines200Response {
    return GetCheckoutTimelines200ResponseFromJSONTyped(json, false);
}

export function GetCheckoutTimelines200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCheckoutTimelines200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCheckoutTimelines200ResponseAllOfDataFromJSON(json['data']),
        'meta': ResponseSuccessWithPagingAllOfMetaFromJSON(json['meta']),
    };
}

export function GetCheckoutTimelines200ResponseToJSON(value?: GetCheckoutTimelines200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCheckoutTimelines200ResponseAllOfDataToJSON(value.data),
        'meta': ResponseSuccessWithPagingAllOfMetaToJSON(value.meta),
    };
}

